export default __webpack_public_path__ + "static/header-iconic-link-company-link-icon2.url-4f59b898a3ce0d825c3b3be195cd4e95.svg";